<template>
	<div>
        <div class="customPopup">
		<div class="viewPlaceholder text-center">
        <img src="../../../../static/fxView/images/signOut.png" alt="Icon">
          <p>Are you sure you want to edit this field?</p>
          <div class="buttonSign d-flex">
		   <a class="prism_btn greenBG minAuto" href="#" @click="$parent.showEditConfirm = '2' ; $parent.editFunc($parent.getType)">ok</a>
		   <a class="prism_btn redBG minAuto" href="#" @click="$parent.showEditConfirm = '0'">cancel</a>
         </div>
        </div>
       </div>
       <div class="overlayPop"></div>
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'CONFIRMATION',
        mixins: [fxViewMixins],
        data() {
            return {
                pageTitle: this.$options.name,
            }
        },
        
    }
</script>


// WEBPACK FOOTER //
// src/components/website/shared/confirmation.vue